import { BusinessMembers, OrgAccount, OrgBusinessMembersAccount } from '@/types/org'
import { Role, User } from '@/types/user'
import { createQuery } from '../api/query'

export const keyUsers = [`/users`]
export const useQueryUsers = createQuery<User[]>({
    key: keyUsers,
    url: '/users',
})

const keyUserRoles = [`/roles`]
export const useQueryUserRoles = createQuery<Role[]>({
    key: keyUserRoles,
    url: '/roles',
})

const KeyUpdateInvites = (arg: string) => [`/update-invitation`, arg]
export const useQueryUpdateInvites = createQuery<Role[]>({
    key: KeyUpdateInvites,
    url: '/update-invitation',
})

export const KeyInvites = (arg: string) => [`/workspace-users`, arg]
export const useQueryInvites = createQuery<OrgAccount[]>({
    key: KeyInvites,
    url: '/workspace-users',
})

export const KeyBusinessMembers = (arg: string) => [`/business-accounts`, arg]
export const useQueryBusinessMembers = createQuery<BusinessMembers>({
    key: KeyBusinessMembers,
    url: '/business-accounts',
})

export const KeyMemberWorkspaces = (arg: string) => [`/user-workspaces`, arg]
export const useQueryMemberWorkspaces = createQuery<OrgBusinessMembersAccount[]>({
    key: KeyMemberWorkspaces,
    url: '/user-workspaces',
})
